<template>
  <a-modal
    :visible="visible"
    @cancel="handleCancel"
    :mask="false"
    :footer="null"
  >
    <iframe :src="iframeUrl" frameborder="0" width="100%" height="100%"></iframe>
  </a-modal>
</template>
<script>
export default {
  name: 'RobotModal',
  data () {
    return {
      visible: false,
      iframeUrl: 'https://ydzt.jszwfw.gov.cn/jmopen_files/webapp/html5/jssszrznkfihtjl/index.html?token=83a08f67e3ef458880b70b556439dd512edf702728c44c9cbf051312264a35d3#/'
    }
  },
  methods: {
    handleCancel () {
      this.visible = false
    },
    open () {
      this.visible = true
    }
  }
}
</script>
<style lang='less' scoped>
::v-deep .ant-modal{
  width: 520px;
  height: 100%;
  display: flex;
  position: fixed;
  top:0;
  right: 12px;
  padding: 0;
}
::v-deep .ant-modal-content{
  height: 70%;
  margin: 30% auto auto;
}
::v-deep .ant-modal-body{
  height: 100%;
  padding: 0;
}
::v-deep iframe{
  width: 340px;
}
</style>
